import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  TimePicker,
} from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { getAllCourses, getVideoContent, setCourseId } from "redux/actions";
import { updateQuiz } from "redux/actions/Quiz";

const formItemLayout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const widthFull = { width: "100%" };

const transformData = (data) => {
  return data.map((item) => {
    const transformedItem = {
      question: item.question,
      questionType: item.questionType,
      questionPoints: item.questionPoints,
    };

    if (item.questionType === "YES_NO") {
      const answer = item.answers.find((answer) => answer.isCorrect);
      if (answer) {
        transformedItem.answer = answer.answerText;
      }
    } else if (item.questionType === "MULTIPLE_CHOICE") {
      transformedItem.options = {};
      const correctAnswer = item.answers.find((answer) => answer.isCorrect);

      item.answers.forEach((answer, index) => {
        transformedItem.options[(index + 1).toString()] = answer.answerText;
      });

      if (correctAnswer) {
        transformedItem.answer = `option${Object.keys(
          transformedItem.options
        ).find(
          (key) => transformedItem.options[key] === correctAnswer.answerText
        )}`;
      }
    } else if (item.questionType === "OPEN_ENDED") {
      const answer = item.answers[0];
      if (answer) {
        transformedItem.answer = answer.answerText;
      }
    }

    return transformedItem;
  });
};

function secondsToTime(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const pad = (num) => (num < 10 ? `0${num}` : num);

  return `${pad(hours)}:${pad(minutes)}:${pad(remainingSeconds)}`;
}

function EditQuiz({ data, closeModel }) {
  const [questionRandom, setQuestionRandom] = useState(true);
  const [answerRandom, setAnswerRandom] = useState(true);
  const [emailUser, setEmailUser] = useState(false);
  const [selectedTime, setSelectedTime] = useState(data.completionTime);
  const [form] = useForm();
  const dispatch = useDispatch();
  const { courses } = useSelector(({ products }) => products);
  const { videoContent } = useSelector(({ videoContent }) => videoContent);

  useEffect(() => {
    dispatch(getAllCourses());
  }, [dispatch]);

  const handleTimeChange = (time, timeString) => {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);

    setSelectedTime(hours * 3600 + minutes * 60 + seconds);
  };

  const onEditQuiz = (values) => {
    const payload = {
      ...values,
      quizType: values?.module ? "module" : "course",
      courseId: values?.course ? values?.course : null,
      moduleId: values?.module ? values?.module : null,
      completionTime: selectedTime,
      releaseDate: values?.releaseDate ? values?.releaseDate : null,
      numbersOfDaysToRelease: values?.numbersOfDaysToRelease
        ? values?.numbersOfDaysToRelease
        : null,
    };
    const outputArray = values.data.map((item) => {
      const outputItem = {
        questionType: item.questionType,
        question: item.question,
        questionPoints: item.questionPoints,
        answers: [],
      };

      if (item.questionType === "YES_NO") {
        outputItem.answers.push(
          { answerText: "yes", isCorrect: item.answer === "yes" },
          { answerText: "no", isCorrect: item.answer === "no" }
        );
      } else if (item.questionType === "MULTIPLE_CHOICE" && item.options) {
        for (const key in item.options) {
          const option = item.options[key];
          outputItem.answers.push({
            answerText: option,
            isCorrect: key == item.answer.split("option")[1],
          });
        }
      } else if (item.questionType === "OPEN_ENDED") {
        outputItem.answers.push({
          answerText: item.answer,
          isCorrect: true,
        });
      }

      return outputItem;
    });
    payload.data = outputArray;
    payload._id = data._id;
    dispatch(updateQuiz(payload, closeModel));
  };
  const changeRadio = (e, cb) => {
    cb(e.target.value);
  };

  const handleCourseChange = (id) => {
    dispatch(setCourseId(id));
    dispatch(getVideoContent());
    form.resetFields(["module"]);
  };

  useEffect(() => {
    dispatch(setCourseId(data.courseId._id));
    dispatch(getVideoContent());
  }, []);

  const onFinishFailed = (errorInfo) => {
    const errorFields = errorInfo.errorFields;
    if (errorFields.length > 0) {
      form.scrollToField(errorFields[0].name[0]);
    }
  };

  return (
    <>
      <Form
        {...formItemLayout}
        form={form}
        onFinish={onEditQuiz}
        onFinishFailed={onFinishFailed}
        name="edit_quiz"
        initialValues={
          data
            ? {
                ...data,
                course: data.courseId._id,
                module: data.moduleId && data.moduleId._id,
                completionTime: moment(
                  secondsToTime(data.completionTime),
                  "HH:mm:ss"
                ),
                data: transformData(data.data),
                releaseDate: data.releaseDate ? moment(data.releaseDate) : "",
              }
            : {}
        }
      >
        <Form.Item name="course" label="Course" rules={[{ required: true }]}>
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            optionFilterProp="children"
            placeholder="Please select"
            onChange={handleCourseChange}
          >
            {courses &&
              courses.map((ct) => {
                return <Select.Option key={ct._id}>{ct.title}</Select.Option>;
              })}
          </Select>
        </Form.Item>

        <Form.Item name="module" label="Module">
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            placeholder="Please select"
            allowClear
            optionFilterProp="children"
          >
            {videoContent &&
              videoContent.map((ct) => {
                return (
                  <Select.Option key={ct} value={ct._id}>
                    {ct.title}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>

        <Form.Item
          name="releaseSchedule"
          label="Release on"
          rules={[{ required: true, message: "Please select release time" }]}
        >
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            optionFilterProp="children"
            placeholder="Please select"
            getPopupContainer={() => document.getElementById("edit_quiz")}
            onChange={() =>
              form.resetFields(["releaseDate", "numbersOfDaysToRelease"])
            }
          >
            {["Immediately", "Days after enrollment", "Date"].map((ct) => {
              return <Select.Option key={ct}>{ct}</Select.Option>;
            })}
          </Select>
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) =>
            prev.releaseSchedule !== curr.releaseSchedule
          }
        >
          {({ getFieldValue }) =>
            getFieldValue("releaseSchedule") === "Date" ? (
              <Form.Item
                name="releaseDate"
                label="Release Date"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (
                        value === undefined &&
                        getFieldValue("releaseSchedule") === "Date"
                      ) {
                        return Promise.reject("Release date is required");
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <DatePicker
                  style={{
                    width: "100%",
                  }}
                  disabledDate={(current) =>
                    current && current.isBefore(moment().subtract(1, "day"))
                  }
                />
              </Form.Item>
            ) : getFieldValue("releaseSchedule") === "Days after enrollment" ? (
              <Form.Item
                name="numbersOfDaysToRelease"
                label="Days After Enrollment"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (
                        value === undefined &&
                        getFieldValue("releaseSchedule") ===
                          "Days after enrollment"
                      ) {
                        return Promise.reject(
                          "Days After Enrollment is required"
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <InputNumber
                  style={{
                    width: "100%",
                  }}
                />
              </Form.Item>
            ) : null
          }
        </Form.Item>

        <Form.Item name="prerequisits" label="Prerequisite">
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            optionFilterProp="children"
            placeholder="Please select"
            getPopupContainer={() => document.getElementById("edit_quiz")}
          >
            {["None", "Course completion"].map((ct) => {
              return <Select.Option key={ct}>{ct}</Select.Option>;
            })}
          </Select>
        </Form.Item>

        <Form.Item name="passingPercentage" label="Passing Score(%)">
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item name="questionPerPage" label="question Per Page">
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) =>
            prev.restriction_on_repetition !== curr.restriction_on_repetition
          }
        >
          <Form.Item name="repetations" label="Number of attempts">
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Form.Item>

        <Form.Item name="completionTime" label="Auto Submit After">
          <TimePicker
            style={{ width: "100%" }}
            format="HH:mm:ss"
            onChange={handleTimeChange}
          />
        </Form.Item>

        <Form.Item name="randomQuestions" label="Randomize questions?">
          <Radio.Group
            onChange={(e) => changeRadio(e, setQuestionRandom)}
            value={questionRandom}
          >
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item name="randomAnswers" label="Randomize answers?">
          <Radio.Group
            onChange={(e) => changeRadio(e, setAnswerRandom)}
            value={answerRandom}
          >
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item name="emailNotification" label="Email notification to user?">
          <Radio.Group
            onChange={(e) => changeRadio(e, setEmailUser)}
            value={emailUser}
          >
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.List
          name="data"
          rules={[
            {
              validator: async (_, questions) => {
                if (!questions || questions.length < 1) {
                  return Promise.reject(
                    new Error("At least 1 questions required")
                  );
                }
              },
            },
          ]}
        >
          {(fields, { add, remove }, { errors }) => (
            <>
              {fields.map(({ key, name, ...restField }, index) => (
                <>
                  <Row gutter={16}>
                    <Col className="gutter-row" span={19}>
                      <Form.Item
                        label="Question"
                        name={[name, "question"]}
                        rules={[{ required: true }]}
                      >
                        <Input.TextArea />
                      </Form.Item>
                      {/* <Form.Item
                        label="Question points"
                        name={[name, "questionPoints"]}
                        rules={[{ required: true }]}
                      >
                        <InputNumber min={1} style={{ width: "100%" }} />
                      </Form.Item> */}
                      <Form.Item
                        label="Question Type"
                        name={[name, "questionType"]}
                        rules={[{ required: true }]}
                      >
                        <Select
                          style={{
                            width: "100%",
                          }}
                          showSearch
                          allowClear
                          optionFilterProp="children"
                          placeholder="Please select"
                          getPopupContainer={() =>
                            document.getElementById("edit_quiz")
                          }
                        >
                          {["YES_NO", "MULTIPLE_CHOICE", "OPEN_ENDED"].map(
                            (ct) => {
                              return (
                                <Select.Option key={ct}>{ct}</Select.Option>
                              );
                            }
                          )}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        noStyle
                        shouldUpdate={(prev, curr) => {
                          return (
                            prev.data[index]?.questionType !==
                            curr.data[index]?.questionType
                          );
                        }}
                      >
                        {({ getFieldValue }) =>
                          getFieldValue(["data", index, "questionType"]) ===
                          "YES_NO" ? (
                            <Form.Item
                              label="Answer"
                              name={[name, "answer"]}
                              rules={[{ required: true }]}
                            >
                              <Select
                                style={{
                                  width: "100%",
                                }}
                                showSearch
                                allowClear
                                optionFilterProp="children"
                                placeholder="Please select"
                                getPopupContainer={() =>
                                  document.getElementById("edit_quiz")
                                }
                              >
                                {["yes", "no"].map((ct) => {
                                  return (
                                    <Select.Option key={ct}>{ct}</Select.Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          ) : getFieldValue(["data", index, "questionType"]) ===
                            "OPEN_ENDED" ? (
                            <Form.Item
                              label="Answer"
                              name={[name, "answer"]}
                              rules={[{ required: true }]}
                            >
                              <Input.TextArea />
                            </Form.Item>
                          ) : getFieldValue(["data", index, "questionType"]) ===
                            "MULTIPLE_CHOICE" ? (
                            <>
                              {["1", "2", "3", "4"].map((item) => {
                                return (
                                  <Form.Item
                                    label={`option ${item}`}
                                    name={[name, "options", item]}
                                    rules={[{ required: true }]}
                                  >
                                    <Input.TextArea />
                                  </Form.Item>
                                );
                              })}
                              <Form.Item
                                label="Answer"
                                name={[name, "answer"]}
                                rules={[{ required: true }]}
                              >
                                <Select
                                  showSearch
                                  style={{
                                    width: "100%",
                                  }}
                                  allowClear
                                  optionFilterProp="children"
                                  placeholder="Please select"
                                  getPopupContainer={() =>
                                    document.getElementById("edit_quiz")
                                  }
                                >
                                  {[
                                    "option1",
                                    "option2",
                                    "option3",
                                    "option4",
                                  ].map((ct, i) => {
                                    return (
                                      <Select.Option key={ct} value={ct}>
                                        {ct}
                                      </Select.Option>
                                    );
                                  })}
                                </Select>
                              </Form.Item>
                            </>
                          ) : null
                        }
                      </Form.Item>
                    </Col>
                    <Col
                      className="gutter-row"
                      span={5}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        icon={<MinusCircleOutlined />}
                        onClick={() => remove(name)}
                      >
                        Remove
                      </Button>
                    </Col>
                  </Row>
                </>
              ))}

              <Form.Item
                style={{ width: "100%", margin: "0 auto" }}
                wrapperCol={{ span: 16, offset: 4 }}
                labelCol={{ span: 0 }}
              >
                <Button
                  style={{ ...widthFull }}
                  type="dashed"
                  block
                  onClick={() => add()}
                  icon={<PlusOutlined />}
                >
                  Add Question
                </Button>
                <Form.ErrorList errors={errors} style={{ margin: "10px" }} />
              </Form.Item>
            </>
          )}
        </Form.List>

        <Form.Item
          style={{ width: "100%", margin: "15px auto" }}
          wrapperCol={{ span: 4, offset: 10 }}
          labelCol={{ span: 0 }}
        >
          <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}

export default EditQuiz;
